import * as React from "react"
const SvgShareLarge = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={80}
    height={80}
    fill="none"
    {...props}
  >
    <circle cx={40} cy={40} r={40} fill="#9C997C" />
    <path
      fill="#fff"
      d="M20.537 40.006c0 .725-.193 1.403-.515 1.984a4.03 4.03 0 0 1-3.504 2.048 4.027 4.027 0 0 1-4.018-4.032c0-2.226 1.8-4.033 4.018-4.033a3.98 3.98 0 0 1 3.488 2.049c.338.58.53 1.258.53 1.984M53.482 15a4.025 4.025 0 0 0-4.019 4.032 4.025 4.025 0 0 0 4.019 4.033 4.025 4.025 0 0 0 4.018-4.033A4.025 4.025 0 0 0 53.482 15m0 41.935a4.025 4.025 0 0 0-4.019 4.033A4.025 4.025 0 0 0 53.482 65a4.025 4.025 0 0 0 4.018-4.032 4.025 4.025 0 0 0-4.018-4.033m-2.83 2.43-31.311-17.76zm-31.311-20.97 31.312-17.76z"
    />
    <path
      stroke="#fff"
      strokeMiterlimit={10}
      strokeWidth={3}
      d="m19.34 38.396 31.313-17.762M20.537 40.006c0 .725-.193 1.403-.515 1.984a4.03 4.03 0 0 1-3.504 2.048 4.027 4.027 0 0 1-4.018-4.032c0-2.226 1.8-4.033 4.018-4.033a3.98 3.98 0 0 1 3.488 2.049c.338.58.53 1.258.53 1.984ZM53.482 15a4.025 4.025 0 0 0-4.019 4.032 4.025 4.025 0 0 0 4.019 4.033 4.025 4.025 0 0 0 4.018-4.033A4.025 4.025 0 0 0 53.482 15Zm0 41.935a4.025 4.025 0 0 0-4.019 4.033A4.025 4.025 0 0 0 53.482 65a4.025 4.025 0 0 0 4.018-4.032 4.025 4.025 0 0 0-4.018-4.033Zm-2.83 2.43-31.311-17.76z"
    />
  </svg>
)
export default SvgShareLarge
